export default "__VITE_ASSET__CLqc0qzg__"